{
  "generic": {
    "no": "Nee",
    "yes": "Ja",
    "text": "Tekst "
  },
  "consent": {
    "defaultLabelText": "Door dit formulier te verzenden, gaat u akkoord met onze ",
    "defaultLabelLink": "privacybeleid"
  },
  "text": {
    "defaultHeadlineText": "Dit is een kop",
    "defaultText": "Dit is een tekstblok",
    "floatingDefaultText": "NIEUW!"
  },
  "button": {
    "submitDefaultText": "Verzenden",
    "instagramDefaultText": "Volg ons",
    "defaultText": "Klik hier",
    "closing": "SLUITEN..."
  },
  "input": {
    "emailLabel": "E-mail",
    "emailPlaceholder": "Voer uw e-mailadres in",
    "passwordLabel": "Wachtwoord",
    "passwordPlaceholder": "Voer wachtwoord in",
    "nameLabel": "Naam",
    "namePlaceholder": "Voer uw naam in",
    "firstNameLabel": "Voornaam",
    "firstNamePlaceholder": "Voer voornaam in",
    "lastNameLabel": "Achternaam",
    "lastNamePlaceholder": "Voer achternaam in",
    "phoneLabel": "Telefoon",
    "phonePlaceholder": "Voer telefoonnummer in",
    "textareaLabel": "Bericht",
    "textareaPlaceholder": "Voer uw bericht in",
    "regularLabel": "Tekst",
    "regularPlaceholder": "Voer tekst in",
    "defaultLabel": "Label",
    "defaultPlaceholder": "Tijdelijke aanduiding",
    "datePlaceholder": "Selecteer datum",
    "stepLabel": "Voer hier uw vraag in"
  },
  "dropdown": {
    "placeholder": "Selecteer een optie",
    "firstItem": "Optie 1",
    "secondItem": "Optie 2",
    "chooseCountry": "Land"
  },
  "buttonList": {
    "firstItem": "Optie 1",
    "secondItem": "Optie 2",
    "option1": "Keuze 1",
    "option2": "Keuze 2",
    "option3": "Keuze 3",
    "subscriptionItem1": "Nieuwsbrief",
    "subscriptionItem2": "Updates",
    "chooseSubscriptionTopics": "Kies abonnementsonderwerpen",
    "other": "Anders",
    "uncheck-all-label": "Ik wil geen van deze e-mails ontvangen"
  },
  "rating": {
    "rateLabel": "Beoordeel ons",
    "npsLabel": "Hoe waarschijnlijk is het dat u ons aanbeveelt?",
    "veryUnsatisfied": "Zeer ontevreden",
    "unsatisfied": "Ontevreden",
    "neutral": "Neutraal",
    "satisfied": "Tevreden",
    "loveIt": "Geweldig!",
    "minValueLabel": "Laag",
    "maxValueLabel": "Hoog",
    "minValueLabelNps": "Niet waarschijnlijk",
    "maxValueLabelNps": "Zeer waarschijnlijk"
  },
  "deadline": {
    "days": "Dagen",
    "hours": "Uren",
    "minutes": "Minuten",
    "seconds": "Seconden"
  },
  "bulletList": {
    "firstItem": "Voordeel 1",
    "secondItem": "Voordeel 2"
  },
  "discountCode": {
    "copyMessage": "Gekopieerd naar klembord!",
    "fallback": "WELCOME10",
    "textDefault": "Uw kortingscode",
    "buttonDefault": "Kopiëren"
  },
  "share": {
    "buttonText": "Delen"
  },
  "common": {
    "label": "Label"
  },
  "wcag": {
    "banner": "Promotionele banner",
    "closeButton": "Sluiten",
    "submitButton": "Formulier verzenden"
  },
  "spinTheWheel": {
    "prizeWonText": "Gefeliciteerd!",
    "prizeWonButtonText": "Claim uw prijs",
    "prizeLostText": "Ahhh, jammer! :-(",
    "prizeLostButtonText": "Klik om te sluiten",
    "spinButtonLabel": "DRAAIEN"
  },
  "memory": {
    "resultWonText": "Goed gedaan! Uw tijd was {elapsedTime}",
    "resultWonButtonText": "Claim uw prijs"
  },
  "stepNavigation": {
    "nextButtonText": "Volgende",
    "previousButtonText": "Terug",
    "lastButtonText": "Sluiten",
    "submitButtonText": "Verzenden"
  },
  "defaultRealTimeMessage": {
    "validationError": "Controleer het formaat van de ingevoerde gegevens.",
    "unknownError": "Er is een onverwacht probleem opgetreden bij het verzenden.",
    "conflictError": "Deze gebruiker bestaat al.",
    "success": "Formulier ingediend."
  }
}
